var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.row)?_c('m-skeleton-row-user-card',{attrs:{"sentry-tag":"skeleton-user-card.row"}}):_c('m-skeleton-column-user-card',{attrs:{"sentry-tag":"skeleton-user-card.column"}})
}
var staticRenderFns = []

export { render, staticRenderFns }